/* eslint-disable no-console */
/* global google */
/* global MarkerClusterer */
import Vue from 'vue';
import Util from './util';
import Tracking from './tracking';

const app = document.getElementById('hl-map');

const HLMap = {
	vm: null,
	map: null,
	bounds: null,
	mapMarkers: [],
	markerClusterer: null,
	infoWindow: null,
	boundsPadding: 50,
	qPresent: null,
	route: null,
	api: null,
	placeClass: null,
	waiting: false,
	InitMap() {
		setTimeout(() => {
			HLMap.map = new google.maps.Map(document.getElementById('hl-map-map'), {
				center: { lat: 39.7447, lng: -75.5484 },
				zoom: 11,
				maxZoom: 15,
				minZoom: 11,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false
			});

			// Proceed once the map is idle
			google.maps.event.addListenerOnce(HLMap.map, 'idle', () => {
				// Set up infoWindow and event for when it's closed
				HLMap.infoWindow = new google.maps.InfoWindow();
				google.maps.event.addListener(HLMap.infoWindow, 'closeclick', () => {
					if (HLMap.vm && HLMap.vm.appModel) {
						HLMap.vm.appModel.SelectedPlaceId = 0;
					}
				});
				if (HLMap.qPresent) {
					const qPlaceId = Util.GetParameterByName('PlaceId');
					HLMap.vm.search();
					if (qPlaceId != null) {
						setTimeout(() => {
							HLMap.vm.showPlaceDetails(qPlaceId);
						}, 250);
					}
				} else {
					HLMap.vm.search();
				}

				google.maps.event.addListener(HLMap.map, 'idle', () => {
					if (!HLMap.waiting) {
						HLMap.vm.search();
					}
				});
			});
		}, 250);
	},
	Init() {
		const qFilter = Util.GetParameterByName('Filter');
		const qPlaceId = Util.GetParameterByName('PlaceId');
		const qZIPCode = Util.GetParameterByName('ZIPCode');
		HLMap.qPresent = qZIPCode != null || qFilter != null || qPlaceId != null;

		if (app) {
			HLMap.route = app.dataset.route;
			HLMap.api = app.dataset.api;
			this.vm = new Vue({
				el: app,
				data: {
					loading: false,
					filters: [
						{
							id: 'campgrounds',
							type: 'category',
							name: 'Campgrounds',
							checked: false,
							value: 'campground',
							color: '#0D7984'
						},
						{
							id: 'farmers-markets',
							type: 'query',
							name: `Farmer’s Markets`,
							checked: false,
							value: 'farmers market',
							color: '#C04C00'
						},
						{
							id: 'parks-trails',
							type: 'category',
							name: 'Parks & Trails',
							checked: false,
							value: 'park',
							color: '#7D115D'
						},
						{
							id: 'fitness-centers',
							type: 'category',
							name: 'Fitness Centers',
							checked: false,
							value: 'gym',
							color: '#1B3367'
						},
						{
							id: 'yoga-centers',
							type: 'query',
							name: 'Yoga Centers',
							checked: false,
							value: 'yoga',
							color: '#5c7a00'
						},
						{
							id: 'playgrounds',
							type: 'query',
							name: 'Playgrounds',
							checked: false,
							value: 'playground',
							color: '#ecae24'
						},
						{
							id: 'food-banks',
							type: 'query',
							name: 'Food Banks',
							checked: false,
							value: 'food bank',
							color: '#51aa56'
						}
					],
					appModel: {
						County: '',
						ZipCode: '',
						Places: [],
						SelectedPlaceId: 0,
						SearchRequest: {
							Filter: qFilter === null ? '' : qFilter,
							ZIPCode: qZIPCode === null ? '' : qZIPCode
						}
					}
				},
				computed: {
					filterCount() {
						return !this.filters
							? 0
							: this.filters.reduce((n, val) => {
									return n + val.checked;
							  }, 0);
					}
				},
				methods: {
					searchZipCode() {
						this.appModel.ZipCode = this.appModel.SearchRequest.ZIPCode;
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Search Zip Code', this.appModel.ZipCode);
						this.scrollIntoView();
						const geocoder = new google.maps.Geocoder();
						geocoder.geocode({ address: this.appModel.ZipCode }, (results, status) => {
							// If a good response is retrieved
							if (status === google.maps.GeocoderStatus.OK) {
								if (results[0]) {
									HLMap.map.setCenter(results[0].geometry.location);
									HLMap.map.setZoom(14);
								}
							}
							this.search();
						});
						return 0;
					},
					selectCounty(county, lat, lng) {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Select County', county);
						this.scrollIntoView();
						this.appModel.County = county;
						// this.filters.map(filter => (filter.checked = false)); // eslint-disable-line no-return-assign, no-param-reassign
						if (county === '') {
							this.resetPlaces();
						}

						if (lat && lng) {
							HLMap.map.setCenter({ lat, lng });
							HLMap.map.setZoom(11);
						}
					},
					startOver() {
						this.selectCounty('', 39.6120743, -75.6089846);
						// if (this.markerClusterer !== null) {
						// 	this.markerClusterer.clearMarkers();
						// }
						this.appModel.ZipCode = '';
						this.appModel.SearchRequest.ZIPCode = null;
						this.resetPlaces();
						this.updateUrl();
						HLMap.mapMarkers.forEach(marker => {
							marker.setMap(null);
						});
					},
					search() {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Search');
						this.loading = true;
						const radius = this.getMapRadius();

						const searchPromises = [];

						this.resetPlaces();

						this.filters.forEach(filter => {
							if (filter.checked) {
								searchPromises.push(this.searchFilter(filter, radius));
							}
						});

						Promise.all(searchPromises).then(() => {
							this.appModel.Places.sort((a, b) => {
								if (a.name < b.name) {
									return -1;
								}
								if (a.name > b.name) {
									return 1;
								}
								return 0;
							});

							this.loading = false;
							this.appModel.Places.forEach(place => {
								if (HLMap.mapMarkers.filter(marker => marker.place_id === place.place_id).length === 0) {
									HLMap.mapMarkers.push(this.createMarker(place));
								}
							});
							// eslint-disable-next-line no-new
							// if (HLMap.markerClusterer === null && HLMap.mapMarkers.length > 0) {
							// 	HLMap.markerClusterer = new MarkerClusterer(HLMap.map, HLMap.mapMarkers, {
							// 		imagePath: `/img/map/m`,
							// 		maxZoom: 14
							// 	});
							// } else if (HLMap.markerClusterer !== null) {
							// 	HLMap.markerClusterer.markers = HLMap.mapMarkers;
							// }
							this.updateUrl();
							if (this.appModel.SelectedPlaceId !== 0) {
								this.highlightPlace(this.appModel.SelectedPlaceId);
							}
						});
					},
					searchFilter(filter, radius) {
						return this.getPlaceClass()
							.then(placeClass => {
								if (!this.canUsePlaceClassApi(filter, placeClass)) {
									return Promise.resolve();
								}
								return this.searchFilterPlaceApi(filter, radius, placeClass);
							})
							.catch(() => Promise.resolve());
					},
					getPlaceClass() {
						if (HLMap.placeClass) {
							return Promise.resolve(HLMap.placeClass);
						}
						if (google.maps && google.maps.places && google.maps.places.Place) {
							HLMap.placeClass = google.maps.places.Place;
							return Promise.resolve(HLMap.placeClass);
						}
						if (google.maps && typeof google.maps.importLibrary === 'function') {
							return google.maps.importLibrary('places').then(library => {
								HLMap.placeClass =
									(library && library.Place) || (google.maps && google.maps.places && google.maps.places.Place) || null;
								return HLMap.placeClass;
							});
						}
						return Promise.resolve(null);
					},
					canUsePlaceClassApi(filter, placeClass) {
						if (!placeClass) {
							return false;
						}
						if (filter.type === 'category') {
							return typeof placeClass.searchNearby === 'function';
						}
						if (filter.type === 'query') {
							return typeof placeClass.searchByText === 'function';
						}
						return false;
					},
					getMapCenterLiteral() {
						const center = HLMap.map && HLMap.map.getCenter ? HLMap.map.getCenter() : null;
						if (!center) {
							return null;
						}
						if (typeof center.lat === 'function' && typeof center.lng === 'function') {
							return { lat: center.lat(), lng: center.lng() };
						}
						return center;
					},
					searchFilterPlaceApi(filter, radius, placeClass) {
						const center = this.getMapCenterLiteral();
						if (!placeClass || !center) {
							return Promise.resolve();
						}

						const fields = ['id', 'displayName', 'formattedAddress', 'location', 'businessStatus', 'plusCode'];
						if (filter.type === 'category' && typeof placeClass.searchNearby === 'function') {
							return placeClass
								.searchNearby({
									fields,
									locationRestriction: { center, radius },
									includedTypes: [filter.value],
									maxResultCount: 20
								})
								.then(response => {
									this.appendPlaces(response && response.places ? response.places : [], filter);
								});
						}

						if (filter.type === 'query' && typeof placeClass.searchByText === 'function') {
							return placeClass
								.searchByText({
									fields,
									textQuery: filter.value,
									locationBias: { center, radius },
									maxResultCount: 20
								})
								.then(response => {
									this.appendPlaces(response && response.places ? response.places : [], filter);
								});
						}

						return Promise.reject(new Error('Places API method unavailable'));
					},
					mapPlaceResult(place = {}) {
						const displayName =
							place.displayName && typeof place.displayName === 'object' ? place.displayName.text : place.displayName;
						const location = place.location || null;
						const geometry = place.geometry && place.geometry.location ? place.geometry : { location };

						return {
							...place,
							place_id: place.place_id || place.id || '',
							name: place.name || displayName || '',
							vicinity: place.vicinity || place.formatted_address || place.formattedAddress || '',
							business_status: place.business_status || place.businessStatus || '',
							plus_code: place.plus_code || place.plusCode || null,
							geometry
						};
					},
					isPlaceInDelaware(place) {
						const locationCandidates = [];
						if (place.plus_code && place.plus_code.compound_code) {
							locationCandidates.push(place.plus_code.compound_code);
						}
						if (place.vicinity) {
							locationCandidates.push(place.vicinity);
						}
						if (place.formatted_address) {
							locationCandidates.push(place.formatted_address);
						}
						if (place.formattedAddress) {
							locationCandidates.push(place.formattedAddress);
						}

						if (locationCandidates.length === 0) {
							return true;
						}
						return locationCandidates.some(candidate => /\bDE\b|Delaware/i.test(candidate));
					},
					appendPlaces(results, filter) {
						results.forEach(result => {
							const place = this.mapPlaceResult(result);
							if (!place.place_id || !place.geometry || !place.geometry.location) {
								return;
							}
							if (!this.isPlaceInDelaware(place)) {
								return;
							}
							if (this.appModel.Places.some(existingPlace => existingPlace.place_id === place.place_id)) {
								return;
							}
							place.category = filter.id; // eslint-disable-line no-param-reassign
							place.color = filter.color; // eslint-disable-line no-param-reassign
							this.appModel.Places.push(place);
						});
					},
					highlightPlace(id) {
						this.removeHighlights();
						const placeList = document.getElementById(`place-${id}`);
						if (placeList) {
							placeList.classList.add('active');
							const places = document.getElementById('places');
							const y = placeList.offsetTop;
							places.scrollTo({ top: y - 100, behavior: 'smooth' });
						}
					},
					getMapRadius() {
						const bounds = HLMap.map.getBounds();
						const center = HLMap.map.getCenter();
						if (bounds && center) {
							const ne = bounds.getNorthEast();
							return google.maps.geometry.spherical.computeDistanceBetween(center, ne) / 1.5;
						}
						return 0;
					},
					changeFilter() {
						this.scrollIntoView();
						this.appModel.SearchRequest.Filter = this.filters
							.filter(filter => filter.checked)
							.map(filter => filter.id)
							.join(',');
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Change Filters', this.appModel.SearchRequest.Filter);
						this.search();
					},
					showPlaceDetails(id, event) {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Show Place Details', id);
						this.scrollIntoView();
						this.removeHighlights();
						this.appModel.SelectedPlaceId = id;
						document.getElementById(`place-${id}`).classList.add('active');
						const clickedMarker = this.findMarker(id);
						if (clickedMarker && !this.isViewMobile()) {
							this.pauseSearching();
							HLMap.infoWindow.setContent(clickedMarker.title);
							HLMap.infoWindow.open(HLMap.map, clickedMarker);
							HLMap.map.setZoom(15);
						}
					},
					removeHighlights() {
						const evts = document.getElementsByClassName('place');
						for (let i = 0; i < evts.length; i += 1) {
							evts[i].classList.remove('active');
						}
					},
					resetPlaces() {
						const filterIds = this.filters.map(filter => (filter.checked ? filter.id : 0));
						this.appModel.Places = this.appModel.Places.filter(place => filterIds.indexOf(place.category) > -1);
						HLMap.mapMarkers.forEach(marker => {
							if (filterIds.indexOf(marker.category) < 0) {
								marker.setMap(null);
							}
						});
					},
					createMarker(place) {
						const marker = new google.maps.Marker({
							map: HLMap.map,
							position: place.geometry.location,
							icon: {
								path:
									'M77.692,32.692C77.692,17.399,65.3,5,50,5C34.707,5,22.308,17.399,22.308,32.692c0,5.05,1.381,9.769,3.739,13.846h-0.035   L50,95l23.999-48.462h-0.038C76.332,42.461,77.692,37.743,77.692,32.692',
								fillColor: place.color,
								fillOpacity: 1.0,
								strokeColor: '#000000',
								strokeWeight: 1,
								scale: 0.33,
								anchor: new google.maps.Point(50, 100)
							}
						});
						marker.place_id = place.place_id;
						marker.category = place.category;
						marker.title = place.name;
						google.maps.event.addListener(marker, 'click', () => {
							this.appModel.SelectedPlaceId = place.place_id;
							this.pauseSearching();
							if (this.isViewMobile()) {
								HLMap.infoWindow.setContent(
									`<h4 class="h6 mt-0">${place.name}</h4><p>${place.business_status}</p><p>${place.vicinity}</p>`
								);
							} else {
								HLMap.infoWindow.setContent(place.name);
							}
							HLMap.infoWindow.open(HLMap.map, marker);
							this.highlightPlace(this.appModel.SelectedPlaceId);
						});

						return marker;
					},
					scrollIntoView() {
						try {
							document
								.getElementById('hl-map-scroll-target')
								.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
						} catch (exc) {
							// eslint-disable-next-line no-empty
						}
					},
					clearZIP() {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Clear Zip');
						this.scrollIntoView();
						this.appModel.ZipCode = '';
						this.appModel.SearchRequest.ZIPCode = null;
						this.search();
					},
					updateUrl() {
						const params = { ...this.appModel.SearchRequest };
						let query = `?Filter=${params.Filter}`;
						if (this.appModel.SelectedEvent != null) {
							query += `&PlaceId=${this.appModel.SelectedEvent.Id}`;
						}
						if (params.ZIPCode != null) {
							query += `&ZIPCode=${params.ZIPCode}`;
						}
						window.history.replaceState(params, null, `${HLMap.route}${query}`);
					},
					isViewMobile() {
						return window.innerWidth < 1024;
					},
					locateMe() {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Locate Me');
						// Geolocate
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(
								// Success
								position => {
									// Geocode lat/lng to ZIP Code and set on appModel
									const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
									const geocoder = new google.maps.Geocoder();
									geocoder.geocode({ latLng: latlng }, (results, status) => {
										// If a good response is retrieved, pull ZIP Code from this, set it into the model and search
										if (status === google.maps.GeocoderStatus.OK) {
											if (results[0]) {
												for (let j = 0; j < results[0].address_components.length; j += 1) {
													if (results[0].address_components[j].types[0] === 'postal_code') {
														this.appModel.SearchRequest.ZIPCode = results[0].address_components[j].short_name;
													}
												}
											}
										}
										this.search();
									});
								},
								// Error - just search with defaults
								error => {
									this.search();
								}
							);
						} else {
							// Search with defaults
							this.search();
						}
					},
					showMapMarker(id) {
						Tracking.TrackEvent('Healthy Lifestyle Map', 'Show Map Marker', id);
						const clickedMarker = this.findMarker(id);
						HLMap.infoWindow.setContent(clickedMarker.title);
						this.pauseSearching();
						HLMap.infoWindow.open(HLMap.map, clickedMarker);
					},
					pauseSearching() {
						HLMap.waiting = true;
						setTimeout(() => {
							HLMap.waiting = false;
						}, 1000);
					},
					findMarker(id) {
						return HLMap.mapMarkers.find(m => m.place_id === id);
					}
				},
				created() {
					// Load Google Maps script, which will call MapInit when it's ready/loaded
					const script = document.createElement('script');
					script.src =
						'https://maps.googleapis.com/maps/api/js?key=AIzaSyBRX7wzklCLGuFRHAYhjSpQIq7Efyxj7BE&libraries=places,geometry&callback=HLMapInit&loading=async';
					script.async = true;
					script.defer = true;
					document.getElementsByTagName('head')[0].appendChild(script);

					// const script2 = document.createElement('script');
					// script2.src = 'https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js';
					// script2.async = false;
					// document.getElementsByTagName('head')[0].appendChild(script2);
				}
			});
		}
	}
};

export default HLMap;
window.HLMapInit = HLMap.InitMap;
